import { render, staticRenderFns } from "./OrderDraftItemNote.vue?vue&type=template&id=870f0d2c&"
import script from "./OrderDraftItemNote.vue?vue&type=script&lang=js&"
export * from "./OrderDraftItemNote.vue?vue&type=script&lang=js&"
import style0 from "./OrderDraftItemNote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports